import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import classNames from 'classnames';

import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import PopoverBody from 'reactstrap/lib/PopoverBody';

import { isEqual, map } from 'lodash';

import Moment from 'react-moment';

import RoomLogs from './RoomLogs';
import SuspiciousTransactionsPlayers from './SuspiciousTransactionsPlayers';
import SuspiciousFoldPlayers from './SuspiciousFoldPlayers';

import 'react-widgets/dist/css/react-widgets.css';

import {
  getSuspiciousPlayers,
  getSuspiciousPlayersRooms,
  getRoomLog,
  getBotUsers,
  getSuspiciousSameIPPlayersRooms,
} from '../../../actions/admin';

import * as constants from '../../../constants/constants';
import { Col, Input, Label, Row, UncontrolledPopover } from 'reactstrap';
import PaginationOld from '../Menu/PaginationOld';
import SuspiciousRoomLeftPlayers from './SuspiciousRoomLeftPlayers';
import SuspiciousSameIPPlayers from './SuspiciousSameIPPlayers';

const SEARCH_BY_OPTIONS = [
  { value: "lowerCaseName", label: "Name" },
  { value: "lowerCaseLastName", label: "Last Name" },
  { value: "uid", label: "Player Id" },
];

class SuspiciousPlayers extends React.Component {
  static propTypes = {
    member: PropTypes.shape({
      email: PropTypes.string,
    }),
    suspiciousPlayers: PropTypes.shape({}),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    fetchSuspiciousPlayers: PropTypes.func.isRequired,
    fetchRoomLog: PropTypes.func.isRequired,
    fetchBots: PropTypes.func.isRequired,
  }

  static defaultProps = {
    member: {},
    suspiciousPlayers: [],
  }

  constructor(props) {
    super(props);
    this.state = {
      suspiciousTypes: constants.SUSPICIOUS_PLAYERS,
      currentPage: 0,
      pageSize: 50,
      sortColumn: null,
      sortMode: null,
      filterType: SEARCH_BY_OPTIONS[0].value,
      filterValue: '',
      filteredSortedSuspiciousPlayersArr: [],
    };
  }

  componentDidMount() {
    const { fetchSuspiciousPlayers, fetchBots } = this.props;

    fetchSuspiciousPlayers();
    fetchBots();
  }

  componentDidUpdate(prevProps, prevState) {
    const { suspiciousPlayersArr } = this.props;
    const { filterValue, filterType, sortColumn, sortMode, filteredSortedSuspiciousPlayersArr } = this.state;

    if (
      suspiciousPlayersArr?.length > 0 && (
        suspiciousPlayersArr !== prevProps.suspiciousPlayersArr
        || filterValue !== prevState.filterValue
        || filterType !== prevState.filterType
        || sortColumn !== prevState.sortColumn
        || sortMode !== prevState.sortMode
      )
    ) {

      this.setState({
        filteredSortedSuspiciousPlayersArr: this.filteredSortedSuspiciousPlayersArr(suspiciousPlayersArr, filterValue, filterType, sortColumn, sortMode),
        currentPage: 0
      });
    }

  }


  openModal = (player1, player2) => {
    const { fetchSuspiciousPlayersRooms } = this.props;

    fetchSuspiciousPlayersRooms(player1, player2);

    this.setState({
      openModal: true,
    });
  }

  openModalSameIp = (player1, player2) => {
    const { fetchSuspiciousSameIPPlayersRooms } = this.props;

    fetchSuspiciousSameIPPlayersRooms(player1, player2);

    this.setState({
      openModal: null,
      openModalSameIp: true,
    });
  }

  openRoomModal = (room) => {
    const { fetchRoomLog } = this.props;
    fetchRoomLog(room.roomId);

    console.log('openRoomModal', room);

    this.setState({
      roomId: room.roomId,
      room,
      openRoomModal: true,
    });
  }

  toggle = () => {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
    }));
  }

  toggleSameIp = () => {
    this.setState(prevState => ({
      openModalSameIp: !prevState.openModalSameIp,
    }));
  }

  toggleRoom = () => {
    this.setState(prevState => ({
      openRoomModal: !prevState.openRoomModal,
    }));
  }

  handleClick = (e, index) => {
    e.preventDefault();

    this.setState({
      currentPage: index,
    });
  }

  handleSubsection = (item) => {
    const { suspiciousTypes } = this.state;
    console.log(item, "selectSusType");

    if (suspiciousTypes !== item) {
      this.setState({
        suspiciousTypes: item,
      });
    }
  }

  handlePagination = (e, index) => {
    e.preventDefault();
    this.setState({ currentPage: index});
  };

  toggleSortMode = (column) => {
    const { sortColumn, sortMode } = this.state;

    let newSortColumn = column;
    let newSortMode = 'asc';

    if (sortColumn === column) {
      if (sortMode === 'asc') {
        newSortMode = 'desc';
      } else if (sortMode === 'desc') {
        newSortColumn = null;
        newSortMode = null;
      }
    }
    this.setState({
      sortColumn: newSortColumn,
      sortMode: newSortMode,
    });
  }

  // sortSusPlayers = (susPlayers, sortColumn, sortMode) => {
  //   if (!sortColumn) return susPlayers;

  //   const isAsc = sortMode === 'asc';

  //   return [...susPlayers].sort((a, b) => {
  //     const valA = a[sortColumn] ?? 0;
  //     const valB = b[sortColumn] ?? 0;
  //     return isAsc ? valA - valB : valB - valA;
  //   });
  // };

  sortSusPlayers = (susPlayers, sortColumn, sortMode) => {
    if (!sortColumn) return susPlayers;

    const isAsc = sortMode === 'asc';

    susPlayers.sort((a, b) => {
      const valA = a[sortColumn] ?? 0;
      const valB = b[sortColumn] ?? 0;
      return isAsc ? valA - valB : valB - valA;
    });

    return susPlayers;
  };

  filteredSortedSuspiciousPlayersArr = (suspiciousPlayersArr, filterValue, filterType, sortColumn, sortMode) => {
    const search = filterValue.toLowerCase();

    let newArray;
    if (search) {
      if (filterType === 'lowerCaseName') {
        newArray = suspiciousPlayersArr.filter(player =>
          player.player1Name?.toLowerCase().startsWith(search) || player.player2Name?.toLowerCase().startsWith(search) 
        );
      } else if (filterType === 'lowerCaseLastName') {
        newArray = suspiciousPlayersArr.filter(player => {
          const player1NameParts = player.player1Name.split(' ');
          const player2NameParts = player.player2Name.split(' ');

          const player1LastName = player1NameParts.length > 1 ? player1NameParts[1] : '';
          const player2LastName = player2NameParts.length > 1 ? player2NameParts[1] : '';
          
          return (player1LastName && player1LastName.startsWith(search)) || (player2LastName && player2LastName.startsWith(search));
        });
      } else if (filterType === 'uid') {
        newArray = suspiciousPlayersArr.filter(player =>
          player.player1?.toLowerCase() === search || player.player2?.toLowerCase() === search
        );
      }
    } else {
      newArray = [...suspiciousPlayersArr];
    }

    return this.sortSusPlayers(newArray, sortColumn, sortMode);
  };

  resetSearch = () => {
    this.setState({
      filterType: SEARCH_BY_OPTIONS[0].value,
      filterValue: '',
      sortMode: null,
      sortColumn: null,
    });
  }

  table = () => {
    const {
      // suspiciousPlayersArr,
      t,
      offset,
    } = this.props;

    const { currentPage, pageSize, filterValue, filterType, sortColumn, sortMode, filteredSortedSuspiciousPlayersArr } = this.state;

    return (
      <Fragment>
        {filteredSortedSuspiciousPlayersArr.slice(currentPage * pageSize, (currentPage + 1) * pageSize).map((player, index) => (
          (player.dateAdded && player.player1 && player.player2 && player.count) ? (
            <Fragment key={player.key}>
              <tr key={player.key} className={classNames({ 'allUsers-table-row odd': (index % 2 === 0), 'allUsers-table-row even ': index % 2 !== 0 })}>
                <td className="allUsers-table-col">
                  {player.dateAdded && (
                    <Moment format="DD-MM-YYYY, HH:mm:ss" locale="lv">
                      {player.dateAdded + offset}
                    </Moment>
                  )}
                </td>
                <td className="allUsers-table-col">
                  {`${player.player1Name} ${player.player1IsBot ? ('(B)') : ('')}`}
                </td>
                <td className="allUsers-table-col">
                  {`${player.player2Name} ${player.player2IsBot ? ('(B)') : ('')}`}
                </td>
                <td className="allUsers-table-col">
                  {player.count}
                </td>
                <td className="allUsers-table-col">
                  {player.suspiciousPlays}
                </td>
                <td className="allUsers-table-col">
                  <Button onClick={() => this.openModal(player.player1, player.player2)}>
                    View
                  </Button>
                </td>
              </tr>
            </Fragment>
          ) : (null)
        ))}
      </Fragment>
    );
  }

  render() {
    const {
      t,
      roomData,
      suspiciousPlayersRooms,
      suspiciousSameIPPlayersRooms,
      suspiciousPlayersArr,
      bots,
      offset,
    } = this.props;

    const {
      openModal,
      openRoomModal,
      roomId,
      room,
      suspiciousTypes,
      currentPage,
      pageSize,
      openModalSameIp,
      sortColumn,
      sortMode,
      filterType,
      filterValue,
      filteredSortedSuspiciousPlayersArr,
    } = this.state;

    const dataLength = suspiciousTypes === constants.SUSPICIOUS_PLAYERS ? filteredSortedSuspiciousPlayersArr.length : suspiciousPlayersArr.length;
    const pagesCount = Math.ceil(dataLength / pageSize);

    return (
      <Fragment>
        <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-suspicious-players">
          <PopoverBody className="popover-body">
            A list of players whose actions look suspicious: has made at least 5 purchases per day, has folded at least 5 times per room, or has suspiciously played the cards.
          </PopoverBody>
        </UncontrolledPopover>
        <div className="admin-page-content">
          <h2>
            Suspicious Players
            <Button className="admin-help-button" id="admin-help-button-suspicious-players">
              ?
            </Button>
          </h2>
          <h2>
            {
              map(constants.SUSPICIOUSPLAYERS_TYPES, item => (
                <Button className={classNames('supicious-transactions-label', {'active': suspiciousTypes === item.id })} onClick={() => this.handleSubsection(item.id)}>{item.tLabel}</Button>
              ))
            }
          </h2>
          {
            suspiciousTypes === constants.TRANSACTIONS ? (
              <SuspiciousTransactionsPlayers offset={offset} />
            ) : suspiciousTypes === constants.FOLD ? (
                <SuspiciousFoldPlayers openRoomModal={this.openRoomModal} offset={offset} />
            ) : suspiciousTypes === constants.ROOM_LEFT ? (
                  <SuspiciousRoomLeftPlayers openRoomModal={this.openRoomModal} offset={offset} />
            ) : suspiciousTypes === constants.SAME_IP ? (
                    <SuspiciousSameIPPlayers openRoomModal={this.openRoomModal} openModalSameIp={this.openModalSameIp} offset={offset} />
            ) : (
              <>

                <Row>
    
                  <Col sm="2">
                    <Label for="filterType">
                      Search By
                    </Label>
                    <Input type="select" className="game-bet-select" value={filterType} onChange={(e) => this.setState({filterType: e.target.value})}>
                      {SEARCH_BY_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Input>
                  </Col>
    
                  <Col sm="2">
                    <Label for="filter">
                      Value
                    </Label>
                    <Input
                      type="text"
                      name="filterValue"
                      id="filterValue"
                      value={filterValue}
                      onChange={(e) => this.setState({filterValue: e.target.value})}
                    />
                  </Col>

                  <Col sm="2">
                    <br />
                    <Button onClick={this.resetSearch}>
                      Reset
                    </Button>
                  </Col>
                </Row>
                <br/>

                <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
                  <colgroup>
                    <col span="1" className="" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'center' }}>
                        Date
                      </th>
                      <th style={{ textAlign: 'center' }}>
                        Player 1
                      </th>
                      <th style={{ textAlign: 'center' }}>
                        Player 2
                      </th>
                      <th>
                        <div
                          style={{ textAlign: 'center' }}
                        >
                          <div onClick={() => this.toggleSortMode('count')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            Count
                            <div className="admin-arrow-wrapper admin-arrow-wrapper-small ml-2">

                              <div
                                className={
                                  sortColumn === 'count'
                                    ? (sortMode === 'asc' ? 'admin-arrow-down' : 'admin-arrow-up')
                                    : 'admin-circle'
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </th>
                      {/* <div>{sortColumn}-{sortMode}</div> */}
                      <th>
                        <div
                          style={{ textAlign: 'center' }}
                        >
                          <div onClick={() => this.toggleSortMode('suspiciousPlays')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            Giveaway
                            <div className="admin-arrow-wrapper admin-arrow-wrapper-small ml-2">

                              <div
                                className={
                                  sortColumn === 'suspiciousPlays'
                                    ? (sortMode === 'asc' ? 'admin-arrow-down' : 'admin-arrow-up')
                                    : 'admin-circle'
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ textAlign: 'center' }}>
                        View
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.table()}
                  </tbody>
                </table>
                <PaginationOld
                  show={true}
                  currentPage={currentPage}
                  pagesCount={pagesCount}
                  handlePagination={this.handlePagination}
                />
              </>
            )
          }
        </div>

        <Modal container={`div > div`} isOpen={openModal} toggle={this.toggle} style={{ maxWidth: '65%' }}>
          <ModalHeader toggle={this.toggle}>
            Data
          </ModalHeader>
          <ModalBody>
          <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
            <colgroup>
              <col span="1" className="" />
            </colgroup>
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>
                  Date
                </th>
                <th style={{ textAlign: 'center' }}>
                  Room Id
                </th>
                <th style={{ textAlign: 'center' }}>
                  Bet
                </th>
                <th style={{ textAlign: 'center' }}>
                  Min games
                </th>
                <th style={{ textAlign: 'center' }}>
                  Suspicious cases
                </th>
                <th style={{ textAlign: 'center' }}>
                  View
                </th>
              </tr>
            </thead>
            <tbody>
                {Object.keys(suspiciousPlayersRooms).reverse().map((key, index) => (
                <Fragment key={suspiciousPlayersRooms[key].roomId}>
                  <tr
                    key={suspiciousPlayersRooms[key].roomId}
                    className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}
                    style={suspiciousPlayersRooms[key].suspiciousPlays ? { color: 'red', fontWeight: 'bold' } : null}
                  >
                    <td className="allUsers-table-col">
                      {suspiciousPlayersRooms[key].date && (
                        <Moment format="DD-MM-YYYY, HH:mm:ss" locale="lv">
                          {suspiciousPlayersRooms[key].date}
                        </Moment>
                      )}
                    </td>
                    <td className="allUsers-table-col">
                      {suspiciousPlayersRooms[key].roomId}
                    </td>
                    <td className="allUsers-table-col">
                      {suspiciousPlayersRooms[key].bet}
                    </td>
                    <td className="allUsers-table-col">
                      {suspiciousPlayersRooms[key].minGames}
                    </td>
                    <td className="allUsers-table-col">
                      {suspiciousPlayersRooms[key].suspiciousPlays}
                    </td>
                    <td className="allUsers-table-col">
                      <Button onClick={() => this.openRoomModal(suspiciousPlayersRooms[key])}>
                        View
                      </Button>
                    </td>
                  </tr>
                </Fragment>
              ))}
            </tbody>
          </table>

          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>Close</Button>
          </ModalFooter>
        </Modal>

        <Modal container={`div > div`} isOpen={openModalSameIp} toggle={this.toggleSameIp} style={{ maxWidth: '65%' }}>
          <ModalHeader toggle={this.toggleSameIp}>
            Data
          </ModalHeader>
          <ModalBody>
            <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
              <colgroup>
                <col span="1" className="" />
              </colgroup>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>
                    Date
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Room Id
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Bet
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Min games
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Suspicious cases
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    View
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(suspiciousSameIPPlayersRooms).reverse().map((key, index) => (
                  <Fragment key={suspiciousSameIPPlayersRooms[key].roomId}>
                    <tr
                      key={suspiciousSameIPPlayersRooms[key].roomId}
                      className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}
                      style={suspiciousSameIPPlayersRooms[key].suspiciousPlays ? { color: 'red', fontWeight: 'bold' } : null}
                    >
                      <td className="allUsers-table-col">
                        {suspiciousSameIPPlayersRooms[key].date && (
                          <Moment format="DD-MM-YYYY, HH:mm:ss" locale="lv">
                            {suspiciousSameIPPlayersRooms[key].date}
                          </Moment>
                        )}
                      </td>
                      <td className="allUsers-table-col">
                        {suspiciousSameIPPlayersRooms[key].roomId}
                      </td>
                      <td className="allUsers-table-col">
                        {suspiciousSameIPPlayersRooms[key].bet}
                      </td>
                      <td className="allUsers-table-col">
                        {suspiciousSameIPPlayersRooms[key].minGames}
                      </td>
                      <td className="allUsers-table-col">
                        {suspiciousSameIPPlayersRooms[key].suspiciousPlays}
                      </td>
                      <td className="allUsers-table-col">
                        <Button onClick={() => this.openRoomModal(suspiciousSameIPPlayersRooms[key])}>
                          View
                        </Button>
                      </td>
                    </tr>
                  </Fragment>
                ))}
              </tbody>
            </table>

          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSameIp}>Close</Button>
          </ModalFooter>
        </Modal>

        <Modal container={`div > div`} isOpen={openRoomModal} toggle={this.toggleRoom} style={{ maxWidth: '65%' }}>
          <ModalHeader toggle={this.toggleRoom}>
            {room ? `Room: ${room.roomId}, Game type: ${room.smallGame ? `${room.gameType ? room.gameType : 'P'}M` : `${room.gameType ? room.gameType : 'P'}`}, Bet: ${room.bet}, Speed: ${constants.SPEED_TYPE[room.speed]}, ${room.minGames ? `Min Games: ${room.minGames}` : ''}, ${room.studentRoom ? '2' : (room.fourPRoom ? '4' : '3')} Players, Private: ${roomData?.[room?.roomId]?.privateRoom ? 'Yes' : 'No'}` : ''}
          </ModalHeader>
          <ModalBody>
            <RoomLogs roomData={roomData} roomId={roomId} roomParams={room} bots={bots} offset={offset} />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRoom}>Close</Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  member: state.member || {},
  suspiciousPlayers: state.admin.suspiciousPlayers || {},
  suspiciousPlayersArr: state.admin.suspiciousPlayersArr || [],
  suspiciousPlayersRooms: state.admin.suspiciousPlayersRooms || {},
  suspiciousSameIPPlayersRooms: state.admin.suspiciousSameIPPlayersRooms || {},
  roomData: state.admin.roomData || {},
  bots: state.admin.bots || {},
});

const mapDispatchToProps = {
  fetchSuspiciousPlayers: getSuspiciousPlayers,
  fetchSuspiciousPlayersRooms: getSuspiciousPlayersRooms,
  fetchSuspiciousSameIPPlayersRooms: getSuspiciousSameIPPlayersRooms,
  fetchRoomLog: getRoomLog,
  fetchBots: getBotUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('admin')(SuspiciousPlayers));
